import { Avatar, AvatarImage, AvatarFallback } from "./avatar";
import { Card } from "./card";
import { Button } from "./button";
import { Plus } from "lucide-react";
import { ConnectedUser } from "@/types";

interface Props {
  swimmer: any;
  onAdd: (swimmer: any) => void;
  connectedIds: ConnectedUser[];
}

export function SwimmerCard({ swimmer, onAdd, connectedIds }: Props) {
  const isConnected = connectedIds.some(
    (c) => String(c.id) === String(swimmer.id)
  );

  const fullName = `${swimmer?.fname || ""} ${swimmer?.lname || ""}`;
  const email = swimmer?.email || "";
  const imageUrl =
    swimmer?.image && swimmer.image !== "null"
      ? swimmer.image
      : "/placeholder-avatar.jpg";

  return (
    <Card className="p-4 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between">

        {/* LEFT */}
        <div className="flex items-center space-x-4">
          <Avatar className="h-20 w-20 rounded-lg overflow-hidden">
            <AvatarImage src={imageUrl} />
            <AvatarFallback>IMG</AvatarFallback>
          </Avatar>

          <div>
            <h3 className="font-semibold text-lg">{fullName}</h3>
            <p className="text-muted-foreground text-sm">{email}</p>
          </div>
        </div>

        {/* RIGHT BUTTON */}
        {!isConnected && (
          <Button
            variant="outline"
            className="h-10 w-10 p-0 rounded-full"
            onClick={() => onAdd(swimmer)}
          >
            <Plus className="h-5 w-5" />
          </Button>
        )}
      </div>
    </Card>
  );
}
